/**
 * ENUM Status de um documento.
 */
export enum DokfyDocumentStatusEnum {
    AWAITING_SIGNATURE = 'AWAITING_SIGNATURE',
    SIGNED = 'SIGNED',
    DECLINED = 'DECLINED',
}
